export default __webpack_public_path__ + "static/media/jira-1.2b3a9136.svg";